import { isNotNullable } from '@app/typeGuards/isNotNullable'

export const isObject = (entity: unknown): entity is object & NonNullable<typeof entity> =>
  typeof entity === 'object' && isNotNullable(entity)
